import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-charcoal py-8 sm:py-10" aria-labelledby="guarantee-title" data-id="element-67" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-68" data-mp="223ejvgqjh11c">
        <div className="flex items-center gap-4 rounded-xl border border-gold/25 bg-panel p-4 sm:gap-6 sm:p-6" data-id="element-69" data-mp="222n1j7lyczt0">
          <div className="relative flex h-16 w-16 shrink-0 items-center justify-center rounded-full border-2 border-gold/50 bg-gold/[0.08] sm:h-20 sm:w-20" data-id="element-70" data-mp="1x28pzfl577q8">
            <ShieldCheckIcon className="h-7 w-7 text-gold sm:h-9 sm:w-9" aria-hidden="true" data-id="element-71" data-mp="14gpcerd2hw83" />
            <span className="absolute -bottom-2 rounded-full bg-gold px-2 py-0.5 font-display text-[10px] font-bold uppercase tracking-[0.08em] text-charcoal" data-id="element-72" data-mp="1j6n77q5i5k69">
              7 Days
            </span>
          </div>
          <div data-id="element-73" data-mp="qlwrfdeernu4">
            <h2 id="guarantee-title" className="font-display text-[19px] font-bold uppercase leading-[1.05] tracking-tight text-cream sm:text-2xl" data-id="element-74" data-mp="lpg1qerk91ex">
              Your Investment Is Protected
            </h2>
            <p className="mt-0.5 text-[10.5px] font-bold uppercase tracking-[0.18em] text-gold sm:text-[12px]" data-id="element-75" data-mp="tx1p4novge3h">
              7-Day Total Guarantee
            </p>
            <p className="mt-2 text-[12.5px] leading-snug text-mutedtext sm:text-[14px]" data-id="element-76" data-mp="12rg38mxo1il0">
              You have 7 full days to explore Functional Coach System™, review
              the modules and apply the frameworks to your coaching workflow. If
              it is not right for you, you can request a refund within the
              guarantee period.
            </p>
          </div>
        </div>
      </div>
    </section>;
}